(function() {
  'use strict';
  
  // Evitar múltiples inicializaciones del script
  if (window.DeliverySchedulerLoaded) return;
  window.DeliverySchedulerLoaded = true;
  
  // Referencia al elemento actual (para detectar cuando cambia)
  var currentSchedulerElement = null;
  
  // ===== CONFIGURACIÓN =====
  var _cfg = window.deliverySchedulerConfig || {};
  var CONFIG = {
    minDays: _cfg.minDays || 1,
    cutoff: _cfg.cutoff || 14,
    maxDays: _cfg.maxDays || 30,
    disabledDates: _cfg.disabledDates || [],

    sectors: {
      1: { days: [1,2,3,4,5,6], comunas: ['Las Condes','Vitacura','Independencia','Recoleta','Santiago Centro','Lo Barnechea','Providencia','Conchalí','Ñuñoa'] },
      2: { days: [2,4,5,6], comunas: ['La Granja','La Florida','San Joaquín','San Miguel','Pedro Aguirre Cerda','Lo Espejo','La Cisterna','San Ramón','La Reina','Peñalolén','Macul'] },
      3: { days: [1,2,4,5,6], comunas: ['Renca','Maipú','Cerro Navia','Lo Prado','Quinta Normal','Cerrillos','Estación Central'] },
      4: { days: [1,3], comunas: ['Chicureo'] }
    },

    /* ===== ZONA ÚNICA TEMPORAL - COMENTADO =====
    sectors: {
      1: { days: [1,2,3,4,5,6], comunas: ['Las Condes','Vitacura','Independencia','Recoleta','Santiago Centro','Lo Barnechea','Providencia','Conchalí','Ñuñoa','La Florida','San Joaquín','San Miguel','La Reina','Peñalolén','Macul','Quinta Normal','Estación Central'] }
    },
    ===== FIN ZONA ÚNICA ===== */

    months: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
    dayNames: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
    timezone: 'America/Santiago'
  };

  // Crear mapa comuna -> días
  var comunaMap = {};
  for (var sid in CONFIG.sectors) {
    var sec = CONFIG.sectors[sid];
    for (var i = 0; i < sec.comunas.length; i++) {
      comunaMap[sec.comunas[i]] = sec.days;
    }
  }

  // ===== HORA DE CHILE =====
  // La hora de corte la fija la bodega en Santiago, NO el dispositivo del
  // cliente: un teléfono en otra zona horaria (España, etc.) calculaba otro
  // "hoy" y ofrecía un día de entrega distinto que un computador en Chile.
  // Devuelve un Date cuyos componentes locales corresponden a Chile.
  function nowInChile() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: CONFIG.timezone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      }).formatToParts(new Date());
      var v = {};
      for (var i = 0; i < parts.length; i++) v[parts[i].type] = parts[i].value;
      var hour = parseInt(v.hour, 10);
      if (hour === 24) hour = 0; // algunos motores devuelven 24 a medianoche
      return new Date(parseInt(v.year, 10), parseInt(v.month, 10) - 1,
                      parseInt(v.day, 10), hour, parseInt(v.minute, 10),
                      parseInt(v.second, 10));
    } catch (e) {
      return new Date(); // sin Intl: hora local del dispositivo (comportamiento previo)
    }
  }
  
  // ===== FUNCIÓN DE VALIDACIÓN =====
  function isValidDeliveryDate(dateStr, comunaValue) {
    if (!dateStr || !comunaValue) return false;
    
    var days = comunaMap[comunaValue];
    if (!days || days.length === 0) return false;
    
    var parts = dateStr.split('-');
    if (parts.length !== 3) return false;
    var dt = new Date(parseInt(parts[0]), parseInt(parts[1])-1, parseInt(parts[2]));
    
    var dow = dt.getDay();
    if (dow === 0) return false;
    if (days.indexOf(dow) === -1) return false;
    if (CONFIG.disabledDates.indexOf(dateStr) !== -1) return false;

    var minDate = nowInChile();
    var addDays = CONFIG.minDays;
    if (minDate.getHours() >= CONFIG.cutoff) addDays++;
    minDate.setDate(minDate.getDate() + addDays);
    minDate.setHours(0,0,0,0);

    var maxDate = nowInChile();
    maxDate.setDate(maxDate.getDate() + CONFIG.maxDays);
    maxDate.setHours(23,59,59,999);
    
    return dt >= minDate && dt <= maxDate;
  }
  
  function canCheckout() {
    var scheduler = document.getElementById('delivery-scheduler');
    if (!scheduler) return true;
    
    var comuna = document.getElementById('delivery-comuna');
    var fecha = document.getElementById('delivery-date');
    
    var comunaValue = comuna ? comuna.value : '';
    var fechaValue = fecha ? fecha.value : '';
    
    // Si hay fecha pero es inválida, limpiarla
    if (fechaValue && !isValidDeliveryDate(fechaValue, comunaValue)) {
      if (fecha) fecha.value = '';
      fechaValue = '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Fecha de Entrega': '' } })
      }).catch(function() {});
    }
    
    var fechaValida = isValidDeliveryDate(fechaValue, comunaValue);
    var result = !!(comunaValue && fechaValida);
    
    return result;
  }
  
  function showError() {
    var msg = document.getElementById('delivery-scheduler-message');
    if (msg) {
      msg.textContent = 'Por favor selecciona comuna y fecha de entrega';
      msg.className = 'delivery-scheduler__message is-visible is-error';
    }
    var comuna = document.getElementById('delivery-comuna');
    if (comuna && !comuna.value) {
      comuna.classList.add('is-error');
      comuna.focus();
    }
    var scheduler = document.getElementById('delivery-scheduler');
    if (scheduler) {
      scheduler.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  
  // ===== INTERCEPTOR DE CHECKOUT (siempre activo) =====
  document.addEventListener('click', function(e) {
    var el = e.target;
    while (el && el !== document.body) {
      var isCheckout = false;
      
      var form = el.closest('form');
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        el = el.parentElement;
        continue;
      }
      
      if (el.id === 'checkout') isCheckout = true;
      if (el.name === 'checkout') isCheckout = true;
      if (el.href && el.href.indexOf('checkout') !== -1) isCheckout = true;
      if (el.className && typeof el.className === 'string' && el.className.indexOf('checkout') !== -1) isCheckout = true;
      
      if (el.tagName === 'BUTTON' || el.tagName === 'A' || el.tagName === 'INPUT') {
        var text = (el.textContent || el.innerText || el.value || '').toLowerCase().trim();
        if (text === 'pagar' || text === 'checkout' || text === 'ir a pagar') {
          isCheckout = true;
        }
      }
      
      if (el.tagName === 'BUTTON' && el.type === 'submit') {
        if (form && form.action && form.action.indexOf('checkout') !== -1) {
          isCheckout = true;
        }
      }
      
      if (el.tagName === 'A' && el.href && el.href.indexOf('/checkout') !== -1) {
        isCheckout = true;
      }
      
      if (isCheckout) {
        if (!canCheckout()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showError();
          return false;
        }
      }
      el = el.parentElement;
    }
  }, true);
  
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (form && form.tagName === 'FORM') {
      var action = form.action || form.getAttribute('action') || '';
      
      if (action.indexOf('/cart/add') !== -1) {
        return;
      }
      
      if (action.indexOf('checkout') !== -1) {
        if (!canCheckout()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showError();
          return false;
        }
      }
    }
  }, true);
  
  // ===== CALENDARIO =====
  var currentMonth = nowInChile();
  currentMonth.setDate(1);
  var availableDays = [];
  var comunaSel, dateInput, placeholder, calendar, calMonth, calDays, calPrev, calNext, selDisplay, selText, clearBtn, message;
  
  function getMinDate() {
    var d = nowInChile();
    var add = CONFIG.minDays;
    if (d.getHours() >= CONFIG.cutoff) add++;
    d.setDate(d.getDate() + add);
    d.setHours(0,0,0,0);
    return d;
  }
  
  function getMaxDate() {
    var d = nowInChile();
    d.setDate(d.getDate() + CONFIG.maxDays);
    d.setHours(23,59,59,999);
    return d;
  }
  
  function fmtDate(dt) {
    var m = String(dt.getMonth()+1);
    var d = String(dt.getDate());
    if (m.length < 2) m = '0' + m;
    if (d.length < 2) d = '0' + d;
    return dt.getFullYear() + '-' + m + '-' + d;
  }
  
  function parseDate(s) {
    var p = s.split('-');
    return new Date(parseInt(p[0]), parseInt(p[1])-1, parseInt(p[2]));
  }
  
  function isDayOk(dow) {
    if (dow === 0) return false;
    return availableDays.indexOf(dow) !== -1;
  }
  
  function isDateValid(ds) {
    if (!ds) return false;
    var dt = parseDate(ds);
    if (!isDayOk(dt.getDay())) return false;
    return dt >= getMinDate() && dt <= getMaxDate();
  }
  
  function renderCalendar() {
    if (!calMonth || !calDays) return;
    
    var y = currentMonth.getFullYear();
    var m = currentMonth.getMonth();
    calMonth.textContent = CONFIG.months[m] + ' ' + y;
    
    var minD = getMinDate();
    var maxD = getMaxDate();
    
    if (calPrev) calPrev.disabled = new Date(y, m, 1) <= minD;
    if (calNext) calNext.disabled = new Date(y, m+1, 0) >= maxD;
    
    var first = new Date(y, m, 1);
    var last = new Date(y, m+1, 0);
    var start = first.getDay();
    start = start === 0 ? 6 : start - 1;
    
    var html = '';
    for (var i = 0; i < start; i++) {
      html += '<button type="button" class="delivery-scheduler__day" disabled></button>';
    }
    
    for (var day = 1; day <= last.getDate(); day++) {
      var dt = new Date(y, m, day);
      var ds = fmtDate(dt);
      var dow = dt.getDay();
      var isPast = dt < minD;
      var isFuture = dt > maxD;
      var isDisabled = CONFIG.disabledDates.indexOf(ds) !== -1;
      var isOk = isDayOk(dow) && !isPast && !isFuture && !isDisabled;
      var isSel = dateInput && dateInput.value === ds;
      
      var cls = 'delivery-scheduler__day';
      if (isSel) cls += ' delivery-scheduler__day--selected';
      else if (isPast || isFuture) cls += ' delivery-scheduler__day--past';
      else if (isOk) cls += ' delivery-scheduler__day--available';
      else cls += ' delivery-scheduler__day--unavailable';
      
      var disabled = (!isOk && !isSel) ? ' disabled' : '';
      html += '<button type="button" class="' + cls + '" data-date="' + ds + '"' + disabled + '>' + day + '</button>';
    }
    
    calDays.innerHTML = html;
    
    var btns = calDays.querySelectorAll('.delivery-scheduler__day--available');
    for (var j = 0; j < btns.length; j++) {
      btns[j].addEventListener('click', function(e) {
        selectDate(e.target.getAttribute('data-date'));
      });
    }
  }
  
  function selectDate(ds) {
    if (dateInput) dateInput.value = ds;
    updateCart('Fecha de Entrega', ds);
    showSelected();
    updateMessage();
  }
  
  function showSelected() {
    var ds = dateInput ? dateInput.value : '';
    
    if (!ds) {
      if (selDisplay) selDisplay.style.display = 'none';
      return;
    }
    var dt = parseDate(ds);
    if (selText) {
      selText.textContent = CONFIG.dayNames[dt.getDay()] + ' ' + dt.getDate() + ' de ' + CONFIG.months[dt.getMonth()] + ', ' + dt.getFullYear();
    }
    if (placeholder) placeholder.style.display = 'none';
    if (calendar) calendar.style.display = 'none';
    if (selDisplay) selDisplay.style.display = 'flex';
  }
  
  function clearDate() {
    if (dateInput) dateInput.value = '';
    updateCart('Fecha de Entrega', '');
    if (selDisplay) selDisplay.style.display = 'none';
    if (comunaSel && comunaSel.value) {
      if (placeholder) placeholder.style.display = 'none';
      if (calendar) calendar.style.display = 'block';
      renderCalendar();
    } else {
      if (placeholder) placeholder.style.display = 'flex';
      if (calendar) calendar.style.display = 'none';
    }
    updateMessage();
  }
  
  function handleComunaChange() {
    var comuna = comunaSel ? comunaSel.value : '';
    availableDays = comunaMap[comuna] || [];
    
    if (comuna) {
      updateCart('Comuna de Entrega', comuna);
    }
    
    if (!comuna) {
      if (placeholder) placeholder.style.display = 'flex';
      if (calendar) calendar.style.display = 'none';
      if (selDisplay) selDisplay.style.display = 'none';
      if (dateInput) dateInput.value = '';
      updateMessage();
      return;
    }
    
    var curDate = dateInput ? dateInput.value : '';
    if (curDate && !isDateValid(curDate)) {
      if (dateInput) dateInput.value = '';
      curDate = '';
    }
    
    if (curDate) {
      showSelected();
    } else {
      if (placeholder) placeholder.style.display = 'none';
      if (calendar) calendar.style.display = 'block';
      if (selDisplay) selDisplay.style.display = 'none';
      renderCalendar();
    }
    updateMessage();
  }
  
  function updateCart(k, v) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [k]: v } })
    }).catch(function() {});
  }
  
  function updateMessage() {
    if (!message) return;
    var c = comunaSel ? comunaSel.value : '';
    var d = dateInput ? dateInput.value : '';
    if (c && d && isDateValid(d)) {
      message.textContent = '✓ Despacho agendado';
      message.className = 'delivery-scheduler__message is-visible is-success';
    } else {
      message.className = 'delivery-scheduler__message';
      message.textContent = '';
    }
    if (comunaSel) {
      comunaSel.classList.toggle('is-valid', !!c);
      comunaSel.classList.remove('is-error');
    }
  }
  
  function initScheduler() {
    var scheduler = document.getElementById('delivery-scheduler');
    if (!scheduler) {
      currentSchedulerElement = null;
      return;
    }
    
    comunaSel = scheduler.querySelector('#delivery-comuna');
    dateInput = scheduler.querySelector('#delivery-date');
    placeholder = scheduler.querySelector('#calendar-placeholder');
    calendar = scheduler.querySelector('#delivery-calendar');
    calMonth = scheduler.querySelector('#calendar-month');
    calDays = scheduler.querySelector('#calendar-days');
    calPrev = scheduler.querySelector('#calendar-prev');
    calNext = scheduler.querySelector('#calendar-next');
    selDisplay = scheduler.querySelector('#selected-date-display');
    selText = scheduler.querySelector('#selected-date-text');
    clearBtn = scheduler.querySelector('#clear-date');
    message = scheduler.querySelector('#delivery-scheduler-message');
    
    if (!comunaSel) return;
    
    if (scheduler !== currentSchedulerElement) {
      currentSchedulerElement = scheduler;
      comunaSel.addEventListener('change', handleComunaChange);
      if (calPrev) calPrev.addEventListener('click', handlePrevClick);
      if (calNext) calNext.addEventListener('click', handleNextClick);
      if (clearBtn) clearBtn.addEventListener('click', clearDate);

      // Devolución de caja: guardar/quitar el cart attribute al marcar.
      var cajaCheckbox = scheduler.querySelector('#delivery-devuelve-caja');
      if (cajaCheckbox) {
        cajaCheckbox.addEventListener('change', function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Devuelve Caja': cajaCheckbox.checked ? 'Sí' : '' } })
          }).catch(function () {});
        });
      }
    }
    
    var comunaValue = comunaSel.value;
    var fechaValue = dateInput ? dateInput.value : '';
    
    availableDays = comunaMap[comunaValue] || [];
    
    if (comunaValue && fechaValue && !isValidDeliveryDate(fechaValue, comunaValue)) {
      dateInput.value = '';
      fechaValue = '';
      updateCart('Fecha de Entrega', '');
    }
    
    if (!comunaValue) {
      if (placeholder) placeholder.style.display = 'flex';
      if (calendar) calendar.style.display = 'none';
      if (selDisplay) selDisplay.style.display = 'none';
    } else if (fechaValue && isValidDeliveryDate(fechaValue, comunaValue)) {
      var dt = parseDate(fechaValue);
      if (selText) {
        selText.textContent = CONFIG.dayNames[dt.getDay()] + ' ' + dt.getDate() + ' de ' + CONFIG.months[dt.getMonth()] + ', ' + dt.getFullYear();
      }
      if (placeholder) placeholder.style.display = 'none';
      if (calendar) calendar.style.display = 'none';
      if (selDisplay) selDisplay.style.display = 'flex';
    } else {
      if (placeholder) placeholder.style.display = 'none';
      if (calendar) calendar.style.display = 'block';
      if (selDisplay) selDisplay.style.display = 'none';
      renderCalendar();
    }
    
    updateMessage();
  }
  
  function cleanupAndShow() {
    if (!comunaSel || !dateInput) return;
    
    var comunaValue = comunaSel.value;
    var fechaValue = dateInput.value;
    
    if (comunaValue && fechaValue) {
      if (!isValidDeliveryDate(fechaValue, comunaValue)) {
        dateInput.value = '';
        updateCart('Fecha de Entrega', '');
      }
    }
    
    handleComunaChange();
  }
  
  function handlePrevClick() {
    currentMonth.setMonth(currentMonth.getMonth() - 1);
    renderCalendar();
  }
  
  function handleNextClick() {
    currentMonth.setMonth(currentMonth.getMonth() + 1);
    renderCalendar();
  }
  
  function tryInit() {
    if (document.getElementById('delivery-scheduler')) {
      initScheduler();
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
  
  window.addEventListener('pageshow', function(event) {
    function reinit() {
      var scheduler = document.getElementById('delivery-scheduler');
      if (scheduler) {
        currentSchedulerElement = null;
        initScheduler();
      }
    }
    
    reinit();
    setTimeout(reinit, 100);
    setTimeout(reinit, 300);
    setTimeout(reinit, 500);
    setTimeout(reinit, 1000);
  });
  
  var rafId = null;
  var lastSchedulerCheck = 0;
  var lastVisualState = '';
  
  function checkScheduler() {
    var now = Date.now();
    if (now - lastSchedulerCheck >= 300) {
      lastSchedulerCheck = now;
      var scheduler = document.getElementById('delivery-scheduler');
      
      if (scheduler) {
        var freshComuna = scheduler.querySelector('#delivery-comuna');
        var freshDate = scheduler.querySelector('#delivery-date');
        var freshPlaceholder = scheduler.querySelector('#calendar-placeholder');
        var freshCalendar = scheduler.querySelector('#delivery-calendar');
        var freshSelDisplay = scheduler.querySelector('#selected-date-display');
        
        if (freshComuna) {
          var comunaVal = freshComuna.value;
          var dateVal = freshDate ? freshDate.value : '';
          
          var expectedPlaceholder = !comunaVal ? 'flex' : 'none';
          var expectedCalendar = (comunaVal && !dateVal) ? 'block' : 'none';
          var expectedSelDisplay = (comunaVal && dateVal) ? 'flex' : 'none';
          
          var actualPlaceholder = freshPlaceholder ? freshPlaceholder.style.display : '';
          var actualCalendar = freshCalendar ? freshCalendar.style.display : '';
          var actualSelDisplay = freshSelDisplay ? freshSelDisplay.style.display : '';
          
          if (actualPlaceholder !== expectedPlaceholder || 
              actualCalendar !== expectedCalendar || 
              actualSelDisplay !== expectedSelDisplay ||
              scheduler !== currentSchedulerElement) {
            initScheduler();
          }
        }
      } else if (currentSchedulerElement) {
        currentSchedulerElement = null;
      }
    }
    rafId = requestAnimationFrame(checkScheduler);
  }
  
  if (document.readyState === 'complete') {
    checkScheduler();
  } else {
    window.addEventListener('load', checkScheduler);
  }
  
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    } else {
      if (!rafId) {
        checkScheduler();
      }
    }
  });
})();